<template>
  <span>
    <i class="el-icon-remove-outline" v-if="index!==0" @click="delOneData()"></i>
    <span class="span4" @click="addSpotType('和')" v-show="index ==0">和</span>
    <span class="span4" v-show="index ==0" @click="addSpotType('或')">或</span>
  </span>
</template>

<script>
export default {
  props:{
    arr:{
      type:Array,
      default:()=>{return []}
    },
    index:{
      type:Number,
      default:0,
    },
    addObj:{
      type:Object,
      default:()=>{return {}}
    },
    addAction:{
      type:Boolean,
      default:false,
    },
    delAction:{
      type:Boolean,
      default:false,
    }
  },
  methods:{
    addSpotType (type) {
      var obj = JSON.parse(JSON.stringify(this.addObj));
      obj.addType = type
      if(this.addAction){
        this.$emit("addSpotType",obj)
      }
      this.arr.push(obj)
    },
    delOneData(){
      this.arr.splice(this.index,1)
      if(this.delAction){
        this.$emit("delOneData",obj)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.span4 {
  background: #6680f4;
  color: #fff;
  display: inline-block;
  height: 0.26rem;
  width: 0.26rem;
  line-height: 0.26rem;
  text-align: center;
  border-radius: 50%;
  cursor: pointer;
  font-size: 0.14rem;
  margin-right: 0.05rem;
}
i{
  font-size: 0.25rem;
}
</style>